import React, { Component } from "react";
import Footer from "../../footer";
import Logos from "./logos";
import { Route } from "react-router-dom";
import {
  footerLinksForEmptyLayout,
  footerLinksForMainLayout,
} from "../../../data/footerLinks";
import { check } from "../../../utils/tokenUtils";

const EmptyLayout = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <div className="content-wrapper">
          <div className="container">
            <main>
              <Logos />
              <Component {...matchProps} />
            </main>
          </div>
          {!rest.hideFooter && (
            <Footer
              links={
                check() ? footerLinksForMainLayout : footerLinksForEmptyLayout
              }
            />
          )}
        </div>
      )}
    />
  );
};

export default EmptyLayout;



// WEBPACK FOOTER //
// ./src/components/layout/empty/index.jsx